import { ERecouvrement } from "./enum/recouvrement";

export class IBMRVegetationAquatique {
    Heterotrophes: number;
    Algues: number;
    Bryophytes: number;
    Pteridophytes: number;
    Phanerogames: number;
    HydrophytesFlottants: number;
    HydrophytesImmerges: number;
    Helophytes: number;

    static mapFromJSON(json): IBMRVegetationAquatique {
        const va = new IBMRVegetationAquatique();

        va.Heterotrophes = json.heterotrophes;
        va.Algues = json.algues;
        va.Bryophytes = json.bryophytes;
        va.Pteridophytes = json.pteridophytes;
        va.Phanerogames = json.phanerogames;
        va.HydrophytesFlottants = json.hydrophytesFlottants;
        va.HydrophytesImmerges = json.hydrophytesImmerges;
        va.Helophytes = json.helophytes;
        
        return va;
    }
}